import { createRootRoute, createRoute, Outlet } from "@tanstack/react-router";
import HomePage from "../components/HomePage";
import HiringPage from "../components/hiringPage/HiringPage";
import TalentPoolPage from "../components/talent/TalentPoolPage.jsx"; // optional
import AdminLogin from "../components/admin/AdminLogin";
import AdminLayout from "../components/admin/AdminLayout";
import AdminDashboard from "../components/admin/AdminDashboard";
import LeadManagement from "../components/admin/LeadManagement";
import TestimonialManagement from "../components/admin/TestimonialManagement";
import ProjectManagement from "../components/admin/ProjectManagement";
import CaseStudyManagement from "../components/admin/CaseStudyManagement";
import ScheduleManagement from "../components/admin/ScheduleManagement";
import SettingsManagement from "../components/admin/SettingsManagement";
import ApiKeyManagement from "../components/admin/ApiKeyManagement";
import EmployeeshipManagement from "../components/admin/EmployeeshipManagement";
import CertificateViewer from "../components/internship/CertificateViewer";
import InternshipListing from "../components/internship/InternshipListing";
import TestingDashboard from "../components/TestingDashboard";
import TestimonialSubmission from "../components/testimonials/SubmissionPage";
import EmployeeRegister from "../components/employee/EmployeeRegister";
import EmployeeLogin from "../components/employee/EmployeeLogin";
import EmployeeDashboard from "../components/employee/EmployeeDashboard";
import EmployeeManager from "../components/admin/EmployeeManager";
import AdminKanbanBoard from "../components/admin/AdminKanbanBoard";

const rootRoute = createRootRoute({
  component: () => <>{<Outlet />}</>,
});

const homeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  component: HomePage,
});

const aboutRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/about",
  component: HomePage,
});

const contactRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/contact",
  component: HomePage,
});

const internshipListingRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/employee-certificates",
  component: InternshipListing,
});

const internshipListingAltRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/employeecertificates",
  component: InternshipListing,
});

const employeeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/employee",
  component: InternshipListing,
});

const employeesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/employees",
  component: InternshipListing,
});

const internshipRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/internship",
  component: InternshipListing,
});

const hallOfFameRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/halloffame",
  component: InternshipListing,
});

const internshipCertificateRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/employee-certificates/$certificateId",
  component: CertificateViewer,
});

const hiringRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/hiring",
  component: HiringPage,
});

const talentPoolRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/talent/$roleId",
  component: TalentPoolPage,
});

const testingDashboardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/testing",
  component: TestingDashboard,
});

const testimonialSubmissionRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/submit-testimonial",
  component: TestimonialSubmission,
});

const employeeRegisterRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/employee/register",
  component: EmployeeRegister,
});

const employeeLoginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/employee/login",
  component: EmployeeLogin,
});

const employeeDashboardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/employee/dashboard",
  component: EmployeeDashboard,
});

// Admin routes
const adminLoginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/admin/login",
  component: AdminLogin,
});

const adminLayoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/admin",
  component: AdminLayout,
});

const adminDashboardRoute = createRoute({
  getParentRoute: () => adminLayoutRoute,
  path: "/dashboard",
  component: AdminDashboard,
});

const adminLeadsRoute = createRoute({
  getParentRoute: () => adminLayoutRoute,
  path: "/leads",
  component: LeadManagement,
});

const adminTestimonialsRoute = createRoute({
  getParentRoute: () => adminLayoutRoute,
  path: "/testimonials",
  component: TestimonialManagement,
});

const adminProjectsRoute = createRoute({
  getParentRoute: () => adminLayoutRoute,
  path: "/projects",
  component: ProjectManagement,
});

const adminCaseStudiesRoute = createRoute({
  getParentRoute: () => adminLayoutRoute,
  path: "/case-studies",
  component: CaseStudyManagement,
});

const adminSchedulesRoute = createRoute({
  getParentRoute: () => adminLayoutRoute,
  path: "/schedules",
  component: ScheduleManagement,
});

const adminSettingsRoute = createRoute({
  getParentRoute: () => adminLayoutRoute,
  path: "/settings",
  component: SettingsManagement,
});

const adminInternshipsRoute = createRoute({
  getParentRoute: () => adminLayoutRoute,
  path: "/employeeships",
  component: EmployeeshipManagement,
});

const adminEmployeeManagerRoute = createRoute({
  getParentRoute: () => adminLayoutRoute,
  path: "/employee-manager",
  component: EmployeeManager,
});

const adminKanbanBoardRoute = createRoute({
  getParentRoute: () => adminLayoutRoute,
  path: "/kanban",
  component: AdminKanbanBoard,
});

const adminApiKeyManagementRoute = createRoute({
  getParentRoute: () => adminLayoutRoute,
  path: "/api-keys",
  component: ApiKeyManagement,
});

export const routeTree = rootRoute.addChildren([
  homeRoute,
  aboutRoute,
  contactRoute,
  internshipListingRoute,
  internshipListingAltRoute,
  employeeRoute,
  employeesRoute,
  internshipRoute,
  hallOfFameRoute,
  internshipCertificateRoute,
  hiringRoute,
  talentPoolRoute,
  testingDashboardRoute,
  testimonialSubmissionRoute,
  employeeRegisterRoute,
  employeeLoginRoute,
  employeeDashboardRoute,
  adminLoginRoute,
  adminLayoutRoute.addChildren([
    adminDashboardRoute,
    adminLeadsRoute,
    adminTestimonialsRoute,
    adminProjectsRoute,
    adminCaseStudiesRoute,
    adminSchedulesRoute,
    adminSettingsRoute,
    adminApiKeyManagementRoute,
    adminInternshipsRoute,
    adminEmployeeManagerRoute,
    adminKanbanBoardRoute,
  ]),
]);
